import React, { ReactElement, ReactNode } from 'react';
import { Box, Paper } from '@mui/material';
import { useWindowSize } from '../../helper';
import Loader from './Loader';

type Props = {
  loading?: boolean;
  page?: boolean;
  style?: React.CSSProperties;
  reference?: React.Ref<HTMLDivElement>;
  header?: ReactElement;
  labelLoading?: ReactElement;
  loader?: ReactElement;
  elevation?: number;
  children?: ReactNode;
};

const Container: React.FC<Props> = ({
  children,
  loading,
  page,
  style,
  reference,
  header,
  labelLoading,
  loader,
  elevation
}) => {
  const { width } = useWindowSize();

  const maxWidth = page && width > 1200 ? '90%' : '100%';

  return (
    <Box
      sx={{
        width: '100%',
        px: { xs: 0, sm: 2 }
      }}
    >
      <Paper
        ref={reference}
        elevation={elevation ?? 1}
        sx={{
          width: '100%',
          maxWidth,
          margin: '0 auto',
          borderRadius: '25px',
          overflow: 'hidden',
          backgroundColor: 'background.paper',
          ...style
        }}
      >
        {header}

        {loading ? (
          <Box
            sx={{
              minHeight: 400,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1
            }}
          >
            {loader ?? <Loader />}
            {labelLoading}
          </Box>
        ) : (
          <Box
            sx={{
              px: { xs: 2, sm: 3, lg: 4 },
              py: 3
            }}
          >
            {children}
          </Box>
        )}
      </Paper>
    </Box>
  );
};

export default Container;
